/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

import Vue from 'vue';

import VueLazyload from 'vue-lazyload';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Modernizr tests touchevents.
 */

require('browsernizr/test/touchevents');
window.Modernizr = require('browsernizr');

Vue.use(VueLazyload);

/**
 * EventBus used to communicate between the webapplication components.
 * */

window.EventBus = new Vue();

/**
 * Zenscroll is a vanilla JavaScript library that enables animated
 * vertical scrolling to an element or position within your
 * document or within a scrollable element (DIV, etc.).
 */

window.zenscroll = require('zenscroll');
